module.exports = __webpack_public_path__ + "assets/successNote2Note-cf935a.svg";